import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import { useAuth } from "./Auth/AuthPage.jsx";

const BACKEND_HOST = process.env.REACT_APP_BACKEND_HOST;

// Edit-in-place URL box; saves on blur or Enter when the value changed.
export const EditUrl = ({ label, field, value, documentId, onSave }) => {
    const { token, setFeedback } = useAuth();
    const [text, setText] = useState(value || "");
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        setText(value || "");
    }, [value]);

    const save = () => {
        if (saving || text.trim() === (value || "")) return;
        setSaving(true);
        fetch(`${BACKEND_HOST}/events/${documentId}/editUrls`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ [field]: text.trim() })
        })
            .then(res => {
                if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
                return res.json();
            })
            .then(response => {
                setFeedback({ message: response.message || "Saved", color: 'success' });
                if (typeof onSave === "function") onSave();
            })
            .catch(error => {
                console.error(`Error saving ${field}:`, error);
                setFeedback({ message: `Failed to save ${label}`, color: 'error' });
            })
            .finally(() => setSaving(false));
    };

    return (
        <TextField
            size="small"
            variant="standard"
            label={label}
            value={text}
            disabled={saving}
            onChange={(e) => setText(e.target.value)}
            onBlur={save}
            onKeyDown={(e) => { if (e.key === "Enter") e.target.blur(); }}
            sx={{ flex: 1, minWidth: 0 }}
        />
    );
};
